export default __webpack_public_path__ + "static/media/danRed.ee44afec.svg";